import { inject } from 'vue';

import type { GetApiV1HackathonsCurrentResponse } from '~/api/generated';

// Mirrors the payload `FrontendHelper#vue_data` injects into the page
export interface VueData {
  approvedCommunityMember: boolean;
  contributorLevel: number;
  contributorPoints: number;
  coreTeam: boolean;
  flash: Record<string, string>;
  gitlabGraphqlUrl: string;
  gitlabGroups: string[];
  hasDiscordMessages: boolean;
  onboardingIssueUrl: string | null;
  organization: string | null;
  pendingSubmissionsCount: number | null;
  runningHackathon: GetApiV1HackathonsCurrentResponse | null;
  teamMember: boolean;
  userAdmin: boolean;
  userId: number | null;
  username: string | null;
}

export interface UseVueDataReturn extends VueData {
  isAdmin: boolean;
  isSignedIn: boolean;
  isCurrentUserId: (id: number | null | undefined) => boolean;
  isCurrentUsername: (name: string | null | undefined) => boolean;
}

export const NOT_PROVIDED: VueData = {
  approvedCommunityMember: false,
  contributorLevel: 0,
  contributorPoints: 0,
  coreTeam: false,
  flash: {},
  gitlabGraphqlUrl: '',
  gitlabGroups: [],
  hasDiscordMessages: false,
  onboardingIssueUrl: null,
  organization: null,
  pendingSubmissionsCount: null,
  runningHackathon: null,
  teamMember: false,
  userAdmin: false,
  userId: null,
  username: null,
};

export function useVueData(): UseVueDataReturn {
  const vueData = inject<VueData>('vueData') ?? NOT_PROVIDED;
  const isSignedIn = typeof vueData.username === 'string';

  return {
    ...vueData,
    isAdmin: vueData.userAdmin === true,
    isSignedIn,
    isCurrentUserId: id => isSignedIn && vueData.userId === id,
    isCurrentUsername: username => isSignedIn && vueData.username === username,
  };
}
